import React from 'react';
import { Modal as MaterialModal } from '@material-ui/core';
import Icon from 'src/components/Icon/Icon';
import './StatsModal.scss';

interface StatsModalProps {
  toggle: Function,
  linkId: string,
  type?: 'tournament' | 'event'
}

export default function StatsModal({ toggle, linkId, type }: StatsModalProps) {
  const _type = type === 'tournament' ? 'uniquetournament' : 'match';

  const toggleButton = (e) => {
    toggle(e);
  };

  return (
    <MaterialModal
      disableEscapeKeyDown={ true }
      open={ true }
      onClose={ toggleButton }
      className="stats-modal__box"
    >
      <div className="stats-modal__container">
        <div>
          <Icon icon="close" className="stats-modal__close" onClick={ toggleButton } />
        </div>
        <div className="stats-modal__container">
          <iframe
            className="stats-modal__iframe"
            title="Sports Stats"
            src={ `https://s5.sir.sportradar.com/keithhobexchange/${ localStorage.getItem('locale') || 'en' }/${ _type }/${ linkId }` }
          />
        </div>
      </div>
    </MaterialModal>
  );
}
